"use client";

import React from "react";
import HealthcareBannerMobile from "@/components/pageComponent/healthcare/home/healthcareBanMobile";
import Crisis from "@/components/pageComponent/healthcare/home/crisis";
import Dream from "@/components/pageComponent/healthcare/home/dream";
import QuickContact from "@/components/common/QuickContact";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const MobilePage: React.FC = () => {
  return (
    <div className="w-full ">
      <div className="bg-[#191919] w-full blue_shadow z-[99]">
        <GlobalHeaderNew />
      </div>
      <HealthcareBannerMobile />
      <div id="crim">
        <Crisis />
      </div>
      <Dream />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
    </div>
  );
};

export default MobilePage;
